// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ICxl","footer":"Form_footer__7mQ0o"};